module.exports = __webpack_public_path__ + "static/media/banner-210909_3.ca167d63.png";